import moment from "moment";

import useLecture from "hooks/lecture/useLecture";
import useProfile from "hooks/useProfile";

// import KDAImg from "assets/img/kda-logo.png";
// import { lectureTypeToLabel } from "utils/formatter";
import { ILectureEmployee } from './../../api/education/types';

// <!-- 법정의무교육 강좌이수증 -->
const CertificationLegal = ({ courseId, employees }: { courseId: number, employees?: ILectureEmployee[] }) => {
  const profile: any = useProfile();
  const lecture = useLecture(courseId);

  const isClinic = profile && profile.hasOwnProperty("clinic_name");
  const getPlayTime = () => {
    if (!lecture) return;
    let result = '';
    const duration = moment.duration(moment(lecture.complete_date).diff(lecture.start_date));
    if (duration.days()) result += `${duration.days()}일 `;
    if (duration.hours()) result += `${duration.hours()}시간 `;
    if (duration.minutes()) result += `${duration.minutes()}분 `;
    if (duration.seconds()) result += `${duration.seconds()}초 `;
    return result;
  }
  if (!profile || !lecture) return <div />;

  return (
    <section className="resume-view">
      <div className="inner wrap" style={{ display: "block" }}>
        <div className="resume-view-layout">
          <div className="main-layout-box">
            <div className="certificate-box">
              <div className="tit-txt">
                {lecture.lecture_list[0].name}
              </div>
            </div>
            <div className="certificate-box">
              <div className="tit-txt2">
                {lecture.lecture_list[0].collect_flag ? '집합교육' : '개별교육'}
              </div>
            </div>

            <div className="resume-data-box">
              <div className="resume-data-group">
                <div className={`data-list-box ${!employees ? 'more-padding' : ''} no-border`}>
                  <div className="row">
                    <div className="subject">
                      {isClinic ? "병원명" : "성명"}
                    </div>
                    <div className="con">
                      {isClinic ? profile?.clinic_name : profile?.name || ""}
                    </div>
                  </div>
                  {isClinic &&
                  <>
                  <div className="row">
                    <div className="subject">소재지</div>
                    <div className="con">{profile.address}</div>
                  </div>
                  <div className="row">
                    <div className="subject">기관장</div>
                    <div className="con">{profile.rep_name}</div>
                  </div>
                  </>
                  }
                  <div className="row">
                    <div className="subject">교육일시</div>
                    <div className="con">{lecture.start_date} ~ {lecture.complete_date}</div>
                  </div>
                  {isClinic &&
                  <div className="row">
                    <div className="subject">교육장소</div>
                    <div className="con">{profile.clinic_name}</div>
                  </div>
                  }
                  <div className="row">
                    <div className="subject">교육방법</div>
                    <div className="con">{lecture.lecture_list[0].collect_flag ? '집합교육' : '개별교육'}</div>
                  </div>
                  {Array.isArray(employees) &&
                  <div className="row">
                    <div className="subject">이수인원</div>
                    <div className="con">{employees.length + 1} 명</div>
                  </div>
                  }
                  <div className="row">
                    <div className="subject">총 이수 시간</div>
                    <div className="con">{getPlayTime()}</div>
                  </div>
                </div>
              </div>
            </div>
            {Array.isArray(employees) &&
            <div className="course-list">
              <div className="tit">수강자 명단</div>
              <div className="table-box">
                <table>
                  <tr>
                    <th>이름</th>
                    <th>연락처</th>
                    <th>서명</th>
                  </tr>

                  {employees.map((employee) => (
                    <tr>
                      <td>{employee.name}</td>
                      <td>{employee.phoneNumber}</td>
                      <td></td>
                    </tr>
                  ))}
                  <tr>
                    <td>{profile?.rep_name}</td>
                    <td>{profile?.rep_phone_number}</td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </div>
            }
            <div className="certificate-box">
              <div className="tit-txt3">
                {lecture.lecture_list[0].name}을 이상없이 완료하였음을 확인합니다.
              </div>
            </div>
            <div className="certificate-box">
              <div className="date">{moment().format(`YYYY년 M월 DD일`)}</div>
            </div>
            {isClinic &&
            <div className="certificate-box">
              <div className="kda">{profile?.clinic_name}</div>
              {/* <img className="kda-logo" src={KDAImg} alt="img"></img> */}
            </div>
            }
          </div>
        </div>
      </div>
    </section>
  );
};
export default CertificationLegal;
